import { AxiosError, AxiosResponse } from 'axios';
import { generalReducerValues } from '../../../../../../../../General.reducer';
import { useDispatch, useSelector } from 'react-redux';

import { useEffect } from 'react';
import { deleteRequest, getRequest, patchRequest, postRequest } from '../../../../../../../../tools/API/appBackendAPI';
import {
    Performance_Ratings_RatingList_Widget_Reducer_Values,
    storeNewRating,
    storeRatings,
    storeRatingsDataRecived,
    storeRemoveRating,
} from '../reducer';
import _ from 'lodash';
import { IRating } from '../interfaces';
import { useTranslation } from 'react-i18next';
import { MAIN_RATING_INDICATORS } from '../constants/constants';
import { userSettingsReducerValues } from '../../../../../../UserSettings/reducer';

const front2BackPrepare = (arr: Array<{ id: string; text: string; checked: boolean }>) => {
    return arr?.filter((item) => item.checked).map((item) => item.id);
};

const back2FrontPrepare = (rating: any) => {
    const additional_columns = MAIN_RATING_INDICATORS.map((item) => {
        return { ...item, checked: rating.additional_columns.includes(item.id) };
    });
    return { ...rating, additional_columns };
};

export const useRequestRatings = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { token, selectedLocationId, appBackendHost, user } = useSelector(generalReducerValues);
    const { accParamsReceived } = useSelector(userSettingsReducerValues);
    const { newRating, removeRating, ratingsDataRecived, ratings } = useSelector(
        Performance_Ratings_RatingList_Widget_Reducer_Values,
    );
    const url = `${appBackendHost}/api/ratings/ratings/`;

    /** Добавление новых и редактирование */
    useEffect(() => {
        if (newRating !== null) {
            const rating: any = _.cloneDeep(newRating);
            const userId = user?.id;
            rating['user_id'] = userId;
            rating['pl_id'] = selectedLocationId;
            rating['additional_columns'] = front2BackPrepare(rating?.additional_columns);

            if (ratings?.find((x: IRating) => x.id === rating.id)) {
                const oldRatingsDataRecived = _.cloneDeep(ratingsDataRecived);
                const newCurrentStorage: IRating[] = ratings?.map((item: IRating) => {
                    if (item.id === rating.id) {
                        return rating;
                    }
                    return item;
                });
                dispatch(
                    storeRatingsDataRecived(
                        _.remove(oldRatingsDataRecived, function (n) {
                            return n !== rating.id;
                        }),
                    ),
                );
                patchRequest(url, token, rating).then((response: AxiosError | AxiosResponse) => {
                    const url = `${appBackendHost}/api/ratings/ratings/?pl_id=${selectedLocationId}`;
                    getRequest(url, token).then((response: AxiosError | AxiosResponse) => {
                        dispatch(storeRatings(prepareRating(response['data'])));
                    });
                });
                dispatch(storeRatings(prepareRating(newCurrentStorage)));
            } else {
                postRequest(url, token, rating).then((response: AxiosError | AxiosResponse) => {
                    const url = `${appBackendHost}/api/ratings/ratings/?pl_id=${selectedLocationId}`;
                    getRequest(url, token).then((response: AxiosError | AxiosResponse) => {
                        dispatch(storeRatings(prepareRating(response['data'])));
                    });
                });
            }
            dispatch(storeNewRating(null));
        }
    }, [dispatch, newRating, ratings, ratingsDataRecived, selectedLocationId, token, url, user?.id]);

    /** Удаление */
    useEffect(() => {
        if (removeRating) {
            deleteRequest(url, token, removeRating).then(() => {
                const url = `${appBackendHost}/api/ratings/ratings/?pl_id=${selectedLocationId}`;
                getRequest(url, token).then((response: AxiosError | AxiosResponse) => {
                    dispatch(storeRatings(prepareRating(response['data'])));
                });
            });
            dispatch(storeRemoveRating(null));
        }
    }, [dispatch, removeRating, token, url]);

    /** При загрузке приложения, запрос рейтингов */
    useEffect(() => {
        const url = `${appBackendHost}/api/ratings/ratings/?pl_id=${selectedLocationId}`;
        if (token && selectedLocationId && accParamsReceived) {
            dispatch(storeRatings([]));
            getRequest(url, token).then((response: AxiosError | AxiosResponse) => {
                if (response?.['data']?.length) {
                    dispatch(storeRatings(prepareRating(response['data'])));
                }
            });
        }
    }, [selectedLocationId, token, accParamsReceived]);

    /**
     *
     * @param ratingList
     * @returns - массив рейтингов
     */
    const prepareRating = (ratingList: IRating[]) => {
        const storageResult = ratingList.map((item) => back2FrontPrepare(item));
        if (storageResult.length === 0) {
            return null;
        } else {
            return storageResult;
        }
    };
};
